/**
 * Homepage Slider
 *
 * @author Johannes Heimbach
 * @date 2013-08-18
 */

define('controller/slider',[
	'jquery',
    'flexslider'
], function ($) {

	'use strict';

    var _element = null;
    var _me = null;

	return {
		init: function (element) {
            _element = element;
            _me = this;
            $(element).flexslider({
                animation: "slide",
                start: this.setControlNavInCenter,
                init: this.removeInvisibleClass
            });
		},

        setControlNavInCenter: function() {
            var controlNav = $(_element).find('.flex-control-nav');
            var containerWidth = $(_element).width();
            var controlNavWidth = controlNav.width();

            controlNav.css({
                'left': _me.calculateControlNavPosition(containerWidth, controlNavWidth) + '%'
            });
        },


        removeInvisibleClass: function() {
            $(_element).removeClass('invisible');
        },

        calculateControlNavPosition: function(containerWidth, controlNavWidth) {
            var hundredPercent = containerWidth - controlNavWidth;
            var fiftyPercent = hundredPercent * 50;

            return (fiftyPercent / containerWidth);
        }
	};
});

